export enum AcknowledgmentDocumentStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  Cancelled = 4,
}

export enum AcknowledgmentRoleStatus {
  Pending = 1,
  Completed = 2,
  Cancelled = 4,
}
